import axios from "./axios";

export const get = (id) => {
  return {}; // fetchGet(`${Site.api_url}programs?id=${id}`);
};;

export const getWhere = (where, sort = "", limit = 100, offset = 0) => {
  const params = {
    ...where,
    sort,
    limit,
    offset,
  };

  return {}; // fetchGet(`${Site.api_url}programs?${fetchParams(params)}`);
};;

export const save = (data) => {
  return {}; // fetchPost(`${Site.api_url}programs`, data);
};

export const update = (data) => {
  return axios.post("api/programmes", data);
};
